var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-auto-complete", {
        staticStyle: { width: "100%" },
        attrs: {
          dataSource: _vm.nationDataSource,
          placeholder: "请选择民族",
          filterOption: _vm.filterOption,
          allowClear: "",
          disabled: _vm.disabled
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.innerValue,
          callback: function($$v) {
            _vm.innerValue = $$v
          },
          expression: "innerValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }